export enum RelativeDayType {
  today = 'today',
  tomorrow = 'tomorrow',
}

export const BopsPillCopy = {
  [RelativeDayType.today]: 'Pick up today',
  [RelativeDayType.tomorrow]: 'Pick up tomorrow',
} as const;

export type BopsMessageType = (typeof BopsPillCopy)[keyof typeof BopsPillCopy];

export const SddPillCopy = {
  [RelativeDayType.today]: 'Same-Day Delivery',
  [RelativeDayType.tomorrow]: 'Next-Day Delivery',
} as const;

export type SddMessageType = (typeof SddPillCopy)[keyof typeof SddPillCopy];

export interface OrderTimeThreshold {
  hour: number;
  minute: number;
}

export type RelativeDay = 'TODAY' | 'TOMORROW' | 'OTHER';

export interface CutOffTime {
  pickupRelativeDay: RelativeDay;
  orderTimeThreshold: OrderTimeThreshold;
}

export interface SddCutOffTime {
  deliveryRelativeDay: RelativeDay;
  orderTimeThreshold: OrderTimeThreshold;
  sddBuffer: string;
}

export interface LocationInfo {
  link: Array<unknown>;
  locationNumber: number;
  sddMessage?: SddMessageType;
}

export interface WorkingHour {
  openTime: string;
  closeTime: string;
  operationDate?: string;
}

export interface StoreSchedule {
  workingHours?: WorkingHour[];
  curbsideHours?: WorkingHour[];
}

export interface StoreInfo extends LocationInfo {
  curbsideFreePickUpMessage: string;
  bopsFreePickUpMessage: string;
  cutOffTime: CutOffTime;
  sddCutOffTime: SddCutOffTime;
  schedule?: StoreSchedule;
}

export interface StoresData {
  store: StoreInfo[];
}

export interface StoresResponse {
  stores: StoresData;
}

export enum GetItType {
  getItToday = 'getItToday',
  getItTomorrow = 'getItTomorrow',
  getItFast = 'getItFast',
}

export const GetItCopy = {
  [GetItType.getItToday]: 'Get it today',
  [GetItType.getItTomorrow]: 'Get it tomorrow',
  [GetItType.getItFast]: 'Get it fast',
};

export interface StoreInventory {
  bopsEligible: boolean; // pick up eligible
  bossEligible: boolean;
  curbsidePickupEligible: boolean;
  inStorePickupEligible: boolean;
  locationNumber: number;
  sddEligible: boolean;
}

export const BADGE_LOOKUP = {
  // Both Pickup & Delivery are eligible
  both_today_today: 'Pickup or delivery today',
  both_today_tomorrow: 'Pickup or delivery today', // business approved
  both_tomorrow_tomorrow: 'Pickup or delivery tomorrow',

  // Pickup Only
  pickup_today: 'Pick up today',
  pickup_tomorrow: 'Pick up tomorrow',

  // Same-Day / Next-Day Delivery Only
  delivery_today: 'Same-Day Delivery',
  delivery_tomorrow: 'Next-Day Delivery',
} as const;
